import {copilot, users} from '@cl/shared';
import {CLDispatch} from 'common/src/redux/store';
import {ChatType} from '../../copilot.enums';
import assistantPlaintextChatItem from '../../utils/creators/assistantPlaintextChatItem';
import {addChatItem, createChat as createChatAction} from '../copilot.slice';

function createChat(type: ChatType) {
  return (dispatch: CLDispatch) => {
    const chat =
      type === ChatType.Support ? copilot.createSupportChat() : copilot.createGeneralChat();

    copilot.addChat(chat);

    const chatId = chat.id;
    const agentName = chat.agents[0].name;

    dispatch(createChatAction({chatId, type, isPlanModeEnabled: chat.isPlanModeEnabled}));

    const userFirstName = users.userSubject.data?.firstName?.trim();
    const text = userFirstName
      ? `How can I help you today, ${userFirstName}?`
      : 'How can I help you today?';

    dispatch(addChatItem({chatId, chatItem: assistantPlaintextChatItem({agent: agentName, content: text})}));

    return chatId;
  };
}

export default createChat;
